// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"881":"f12547d9","3251":"9b79cbba","3616":"f12547d9","5229":"f12547d9","5394":"f12547d9","5491":"f12547d9","6985":"f12547d9","8488":"86454a2c"}[chunkId] + ".chunk.css";
};